import { headerInfo } from "@/api/header";
const state = {
  is_home: '',
  is_lear_interest: 1,
  a_id: '',
  stateInfo:{},
  studentcms_name:'学生作品展',
  infocms_name:'资讯通告'
}

const mutations = {
  SET_HOME: (state, home) => {
    state.is_home = home
  },
  SET_INTEREST: (state, interest) => {
    state.is_lear_interest = interest
  },
  SET_AID: (state, id)=>{
    state.a_id = id
  },
  SET_STATEINFO: (state, website)=>{
    state.stateInfo = website
  },
  SET_ORGDATA: (state, orgData)=>{
    state.orgData = orgData
  },
  SET_STUDENTCMSNAME : (state, studentcms_name)=>{
    state.studentcms_name = studentcms_name
  },
  SET_INFOCMSNAME : (state, infocms_name)=>{
    state.infocms_name = infocms_name
  },
}

const actions = {
  generateRoutes({ commit }, roles) {
    return new Promise(resolve => {
      headerInfo().then(response => {
        const resData = response.data;
        commit('SET_HOME',resData.website.is_home);
        commit('SET_INTEREST', resData.website.is_lear_interest);
        commit('SET_STATEINFO', resData.website);
        commit("SET_ORGDATA",resData)
        resolve(resData.website);
      }).catch(error => {
        console.log(error);
      });
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js